<template>
    <div>
        <div class="row justify-content-between aling-items-center">
            <div class="col-md-5">
                <label title="Categoria" class="label-form"><span>Categoría</span></label>
                <field-select
                    :value.sync="form.category"
                    :options="categories"
                    :clearable="false"
                    :change="changeCategory"
                />
            </div>
            <div class="col-md-5 search-name-image">
                <field-input
                    :value.sync="form.name"
                    name="search"
                    placeholder="Buscar por nombre"
                    icon="SearchIcon"
                    @input="filterImages"
                />
            </div>
            <div class="col-md-12 mt-2 pr-2 pl-2">
                <div class="row">
                  <b-button 
                    v-if="searchEnviameButton && showEnviameButton"
                    :class="['btn-img-enviame mt-1 mb-50', { selected: selectImage.code === imgEnviame.code }]"
                    @click="selectImageForList(imgEnviame.code, 'enviame')"
                  >
                    <img :src="imgEnviame.logo" width="200" :alt="imgEnviame.name">
                  </b-button>
                </div>
                <div class="row justify-content-center">
                  <b-spinner v-if="filteredCarriers.length === 0"/>
                  <div v-else>
                    <b-button
                      class="mr-50 ml-50"
                      v-for="(carrier, index) in filteredCarriers.slice(0, 10)" 
                      :key="index"
                      :class="['btn-img-carrier', { selected: selectImage.code === carrier.code }]"
                      @click="selectImageForList(carrier.code, 'carrier')"
                    >
                        <img :src="carrier.logo" :alt="carrier.code" class="image-with-alt">
                    </b-button>
                  </div>
                </div>
            </div>
            <div class="col-md-12 d-flex align-items-center justify-content-end mt-3">
                <b-button variant="success" :disabled="!selectImage.code" @click="confirmSelection()">
                  <span>Confirmar</span>
                </b-button>
            </div> 
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      form: {},
      categories: [
        {id: 'all', text: 'Todas'},
        {id: 'couriers', text: 'Carriers'},
        {id: 'marketcenters', text: 'Marketcenters', disabled: true}
      ],
      listCarriers: [],
      filteredCarriers: [],
      selectImage: {
        code: null,
        type: null
      },
      imgEnviame: {id: 'ENV', name: 'Enviame', code: 'ENV', logo: 'https://storage.googleapis.com/marketcenter-labels-local/logo_enviame.svg'},
      showEnviameButton: true,
      selectedImage: null
    }
  },
  watch: {
    carriers (value) {
      this.listCarriers = value
      this.filteredCarriers = this.listCarriers
    }
  },
  computed: {
    ...mapGetters({
      carriers: 'getCarriersNotifications'
    }),
    searchEnviameButton() {
      const normalizedFilter = this.normalizeText(this.form.name || '')
      const normalizedEnviameName = this.normalizeText(this.imgEnviame.name)
      return !normalizedFilter || normalizedEnviameName.includes(normalizedFilter)
    }
  },
  mounted () {
    this.listCarriers = this.carriers
    this.filteredCarriers = this.listCarriers
    this.form.category = this.categories[0]
  },
  methods: {
    normalizeText (text) {
      return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase()
    },
    filterImages(value) {
      if (!!value) {
        const normalizedValue = this.normalizeText(value)
        this.filteredCarriers = this.listCarriers.filter(carrier => {
          const normalizedCarrierName = this.normalizeText(carrier.name)
          const matchesName = normalizedCarrierName.includes(normalizedValue)
          return matchesName
        })
      } 
      else {
        this.filteredCarriers = this.carriers
      } 
    },
    selectImageForList(code, type) {
      this.selectImage = {
        code,
        type
      }
    },
    changeCategory (name, value) {
      this.showEnviameButton = value.id === 'all'
    },
    confirmSelection() {
      this.selectedImage = this.selectImage.type === 'carrier' ? this.listCarriers.find(carrier => carrier.code === this.selectImage.code) : this.imgEnviame
      this.uploadNotificationImage()
    },
    uploadNotificationImage() {
      const infoImage = {
        name: `Logo ${this.selectedImage.name}`, 
        logo: this.selectedImage.logo
      }
      if (this.selectedImage.code !== 'ENV') infoImage.carrier_code = this.selectedImage.code
      this.$emit('saveImage', infoImage)
    }
  }
}
</script>
<style>
.search-name-image {
  display: grid;
  align-items: end;
}
.search-name-image input {
  border-right: 0;
}
.btn-img-carrier, .btn-img-enviame {
  background: none !important;
  border: none !important;
}
.btn-img-carrier:focus, .btn-img-enviame:focus {
  background: none !important;
}
.btn-img-carrier, .btn-img-enviame {
  width: 150px;
  height: 100px;
  padding: 0;
}
.btn-img-carrier img, .btn-img-enviame img {
  width: 80%;
}
.btn-img-carrier.selected, .btn-img-enviame.selected   {
  border: 2px solid #2C3F6F !important;
  background: none !important;
}
.image-with-alt::after {
  content: attr(alt);
  display: none;
  color: #2C3F6F;
}

.image-with-alt:empty::after {
  display: block;
}
</style>